export type GoogleTracking = {
  gclid: string;
};

export type WithGoogleTracking = Partial<GoogleTracking>;

export const GOOGLE_TRACKING_KEY = 'gclid';
